module.exports = __webpack_public_path__ + "img/wells-ems.a5c219ea.svg";